import { validateCnpj } from './cnpj';
import { validateCpf } from './cpf';
import { detectBrazilianDocumentKind, isCnpjDocument, isCpfDocument, normalizeBrazilianDocument } from './normalize';
import { CNPJ_LENGTH, CPF_LENGTH } from './types';

/** Valida CPF (11 dígitos) ou CNPJ (numérico/alfanumérico, 14 caracteres). */
export function validateCpfCnpj(value: string | null | undefined): boolean {
  const clean = normalizeBrazilianDocument(value);
  if (!clean) {
    return false;
  }

  if (isCpfDocument(clean)) {
    return validateCpf(clean);
  }
  if (isCnpjDocument(clean)) {
    return validateCnpj(clean);
  }

  return false;
}

export {
  detectBrazilianDocumentKind,
  isCnpjDocument,
  isCpfDocument,
  normalizeBrazilianDocument,
};

export { validateCpf } from './cpf';
export { validateCnpj } from './cnpj';
export { formatCpf, formatCnpj, formatCpfCnpj } from './format';
